
import { defineComponent, ref } from "vue";
import Menu from "primevue/menu";
import { useBreakpoints, breakpointsTailwind } from "@vueuse/core";
const breakpoints = useBreakpoints(breakpointsTailwind);
const sm = breakpoints.smaller("sm");

export default defineComponent({
  name: "NavBar",
  components: { Menu },
  props: {
    isUserLoggedIn: {
      type: Boolean,
      required: true,
    },
  },
  setup(props, { emit }) {
    const tabClick = (section: string) => {
      emit("tabClick", section);
    };
    const isMobile = () => {
      return window.outerWidth < 376;
    };
    const menuItems = ref([
      {
        label: "Home",
        command: () => {
          tabClick("home");
        },
      },
      {
        label: "Story+",
        command: () => {
          tabClick("story");
        },
      },
      {
        label: "Samples+",
        command: () => {
          tabClick("samples");
        },
      },
      {
        label: "Gallery",
        command: () => {
          tabClick("gallery");
        },
      },
      {
        label: "Pricing",
        command: () => {
          tabClick("pricing");
        },
      },
      {
        label: "Printing",
        command: () => {
          tabClick("printing");
        },
      },
      {
        label: "Purchase",
        command: () => {
          tabClick("generator-wizard");
        },
      },
      {
        label: "Login",
        command: () => {
          tabClick("login");
        },
      },
      {
        label: "Account",
        command: () => {
          tabClick("account");
        },
      },
    ]);
    const menu = ref();
    const toggleMenu = (event: boolean) => {
      menu.value.toggle(event);
    };
    return {
      tabClick,
      isMobile,
      menuItems,
      toggleMenu,
      menu,
      sm,
    };
  },
});
